<template>
  <div v-if="team && team.length" class="project-team" @click.stop="$emit('open-members')">
    <Avatar
      v-for="member in members.avas"
      :key="member.pic"
      v-bind="member"
      class="inner"
      :size="size"
    />
    <Avatar v-if="team.length > +listLength" :name="team.length" class="inner" :size="size" />
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import getStaticApiUrl from '@/utils/get-static-api-url';
  import Avatar from '@/components/avatars/Avatar';

  export default {
    name: 'AvatarList',
    components: { Avatar },
    props: {
      projectId: [Number, String],
      team: {
        type: Array,
        default: () => [],
      },
      size: [Number, String],
      listLength: {
        type: [Number, String],
        default: 3,
      },
    },
    computed: {
      members() {
        return {
          avas: this.team
            ?.filter((member) => member.user && member.user.is_activated)
            .map((member) => ({
              pic: member.user.files_urls.avatar_thumbnail || null,
              name: member.user.name,
              email: member.user.email,
            }))
            .slice(0, 3),
        };
      },
    },
    methods: {
      ...mapActions({
        openModal: 'modal/openModal',
      }),
      getStaticApiUrl,
    },
  };
</script>
